import type { IntegrationProvider } from "./types";
import { SETTING_KEYS } from "@/react/components/entityViews/settings/constants/settingsStructure";

export const INTEGRATION_SETTING_KEYS = {
  openai: SETTING_KEYS.INTEGRATION_OPENAI,
  company_cam: SETTING_KEYS.INTEGRATION_COMPANY_CAM,
} as const satisfies Record<IntegrationProvider, string>;

export const INTEGRATION_PROVIDER_LABELS: Record<IntegrationProvider, string> = {
  openai: "OpenAI",
  company_cam: "CompanyCam",
};

export const INTEGRATION_ERROR_TITLES: Record<IntegrationProvider, string> = {
  openai: "OpenAI integration error",
  company_cam: "CompanyCam integration error",
};

export const COMPANY_CAM_TOKEN_ERROR_MESSAGE =
  "Your CompanyCam API key is invalid or unauthorized. Update it in board settings.";

export const OPENAI_KEY_REQUIRED_TITLE = "OpenAI API Key Required";

export const INTEGRATION_FIX_LABELS: Record<IntegrationProvider, string> = {
  openai: "Configure key",
  company_cam: "Open board settings",
};
